import React, {createContext, useContext, useState} from "react";
import {Layout, Notification} from "../types/utils";

interface NotificationContextValues {
    notification: Notification;
    setNotification: React.Dispatch<React.SetStateAction<Notification>>;
    toast: {
        success: (message: string) => void;
        error: (message: string) => void;
        warning: (message: string) => void;
    };
}

const defaultValues: Notification = {
    open: false,
    message: "",
    severity: "success",
    duration: 5000,
};

const NotificationContext = createContext<NotificationContextValues>({
    notification: defaultValues,
    setNotification: () => {
    },
    toast: {
        success: () => {
        },
        error: () => {
        },
        warning: () => {
        },
    },
});

export const NotificationContextProvider: React.FC<Layout> = ({children}) => {
    const [notification, setNotification] = useState<Notification>(defaultValues);

    const toast = {
        success: (message: string) => {
            setNotification({
                ...notification,
                open: true,
                message,
                severity: "success",
            });
        },
        error: (message: string) => {
            setNotification({
                ...notification,
                open: true,
                message,
                severity: "error",
            });
        },
        warning: (message: string) => {
            setNotification({
                ...notification,
                open: true,
                message,
                severity: "warning",
            });
        },
    };

    return (
        <NotificationContext.Provider
            value={{notification, setNotification, toast}}
        >
            {children}
        </NotificationContext.Provider>
    );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useNotificationContext = () => {
    return useContext(NotificationContext);
};

export type {Notification};

export default NotificationContextProvider;
